module.exports = __webpack_public_path__ + "img/ia-02-6.1346763c.jpg";